import React from "react";
import { object, string } from "prop-types";
import get from "lodash/get";

import "./creator-of-the-month.m.css";
import { Link } from "@quintype/components";
import { STATIC_KEYWORDS } from "../../../constants";

export const CreatorOfTheMonth = ({ collection }) => {
  const items = get(collection, ["items"], []);
  if (!items.length) return null;
  const { EXPLORE_MORE } = STATIC_KEYWORDS;
  const MEDIA_BASE_URL = "https://media.fortuneindia.com/";


  const [featuredItem] = items;
  const getStory = (item) => get(item, ["story"], {});

  const getHeroImageUrl = (story, width) => {
    const directUrl = get(story, ["alternative", "home", "default", "hero-image", "hero-image-url"], "");

    if (directUrl) {
      return `${directUrl}?w=${width}&q=70`;
    }

    const s3Key = get(story, ["hero-image-s3-key"], "");
    if (s3Key) {
      return `${MEDIA_BASE_URL}${s3Key}?w=${width}&q=70`;
    }

    return "";
  };
  const getCreatorMonth = (story) => get(story, ["metadata", "story-attributes", "creatorofthemonth", 0], "");
  const getCreatorName = (story) => get(story, ["headline"], "");
  const getCreatorDesc = (story) => get(story, ["subheadline"], "");
  const getStoryUrl = (story) => get(story, ["url"], "#");
  const getCreatorDesignation = (story) => get(story, ["metadata", "creator-designation"], "");

  return (
      <>
        {featuredItem &&
          (() => {
            const story = getStory(featuredItem);
            const imageUrl = getHeroImageUrl(story, 512);

            if (featuredItem.length < 1) {
              return null;
            }

            return (
              <div styleName="creator-month-home-panel">
                <div className="collection-title-container"><a href={`/${collection?.slug}`}><h3>{collection?.name}</h3></a>
                <Link className="load-more-with-arrow"
                    href={`/${collection?.slug}`}
                    disableAjaxLinks={true}
                  >
                    {EXPLORE_MORE}
                  </Link>
                </div>
                <div styleName="latest-creator-outer">
                  <a href={getStoryUrl(story)}>
                    <div styleName="latest-creator-image">
                      {imageUrl && (
                          <img
                            src={imageUrl}
                            alt={getCreatorName(story)}
                            title={getCreatorName(story)}
                            loading="lazy"
                            width="512"
                            height="512"
                          />
                      )}
                    </div>
                    <div styleName="latest-creator-content">
                      {getCreatorMonth(story) && <div styleName="month-name">{getCreatorMonth(story)}</div>}
                        <div styleName="creator-name">{getCreatorName(story)}</div>
                      <div styleName="creator-designation">{getCreatorDesignation(story)}</div>
                      {getCreatorDesc(story) && <p>{getCreatorDesc(story)}</p>}
                    </div>
                </a>
              </div>
              </div>
            );
          })()}
      </>

  );
};

CreatorOfTheMonth.propTypes = {
  collection: object,
  pageType: string,
};

CreatorOfTheMonth.defaultProps = {
  pageType: "",
};
